import { IconContent } from '@icons';

export const viceVersaArrowsHorizontal: IconContent = {
    sm: '<path d="M2.147 3.646 1.793 4l.354.354 3 3 .707-.708L3.707 4.5H13.5v-1H3.707l2.147-2.146-.707-.708-3 3ZM2.5 11.5h9.793l-2.146 2.146.707.708 3-3 .353-.354-.353-.354-3-3-.707.708 2.146 2.146H2.5v1Z" />',
};
